// TAT Data - start
export const FETCH_TAT_DATA_REQUEST = 'FETCH_TAT_DATA_REQUEST';
export const FETCH_TAT_DATA_SUCCESS = 'FETCH_TAT_DATA_SUCCESS';
export const FETCH_TAT_DATA_FAILURE = 'FETCH_TAT_DATA_FAILURE';
// TAT Data - end